<template>
  <div>
    <b-card title="Polecaj i zarabiaj" class="title-inline recommend">
      <b-row v-if="program === 'sam' && !currentOs">
        <b-col>
          <b-card-text class="mx-4">
            <p class="mb-2">
              Przypominamy, że
              <span class="info-text"
                >z dniem 01.04.2022 roku została zakończona sprzedaż programu
                SAMozatrudnienie<sup>®</sup></span
              >
              nowym Klientom, a od 01.01.2023 roku całkowicie zaprzestaniemy
              wsparcia programu. Dlatego możliwość polecania tego programu innym
              klientom została wyłączona.
            </p>
            <p class="mb-2">
              Jako Użytkownik SAM<sup>®</sup> posiadający aktywną Opiekę
              Serwisową,
              <span class="info-text"
                >z dniem 27.09.2022 r. otrzymasz od nas propozycję BEZPŁATNEGO
                przejścia na program SKP<sup>®</sup></span
              >
              wraz z gwarancją zachowania środków zebranych w „Mój Portfel”. A
              do tego otrzymasz możliwość polecania programu SKP<sup>®</sup> na
              bardziej atrakcyjnych warunkach aniżeli do tej pory.
            </p>
            <p class="mb-2">
              <a
                href="https://www.ksiega-podatkowa.pl/promocje-skp/polec-znajomemu"
                target="_blank"
                >Zobacz pełną listę korzyści dla Polecającego SKP<sup>®</sup> i
                Znajomego ></a
              >
            </p>
            <p class="mb-0">
              W razie pytań prosimy o kontakt mailowy z BOK:
              <a href="mailto:skp@formsoft.pl">skp@formsoft.pl</a>
            </p>
          </b-card-text>
        </b-col>
      </b-row>
      <b-row v-else-if="program === 'sam' && currentOs">
        <b-col>
          <b-card-text class="mx-4">
            <p class="mb-2">
              Przypominamy, że
              <span class="info-text"
                >z dniem 01.04.2022 roku została zakończona sprzedaż programu
                SAMozatrudnienie<sup>®</sup></span
              >
              nowym Klientom, a od 01.01.2023 roku całkowicie zaprzestaniemy
              wsparcia programu. Dlatego możliwość polecania tego programu innym
              klientom została wyłączona.
            </p>
            <p class="mb-2">
              Aby otrzymać od nas propozycję BEZPŁATNEGO przejścia na program
              SKP<sup>®</sup>, zamów Opiekę Serwisową na rok 2022 (w zakładce
              Opieka Serwisowa 2022). Wówczas
              <span class="info-text"
                >z dniem 27.09.2022 r. otrzymasz od nas propozycję BEZPŁATNEGO
                przejścia na program SKP<sup>®</sup></span
              >
              wraz z gwarancją zachowania środków zebranych w „Mój Portfel”. A
              do tego otrzymasz możliwość polecania programu SKP<sup>®</sup> na
              bardziej atrakcyjnych warunkach aniżeli do tej pory. Zobacz pełną
              listę korzyści dla

              <a
                href="https://www.ksiega-podatkowa.pl/promocje-skp/polec-znajomemu"
                target="_blank"
                >Polecającego SKP<sup>®</sup> i Znajomego ></a
              >
            </p>
            <p class="mb-0">
              W razie pytań prosimy o kontakt mailowy z BOK:
              <a href="mailto:skp@formsoft.pl">skp@formsoft.pl</a>
            </p>
          </b-card-text>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
          <b-card-text class="mx-4 text-center">
            <h5 class="my-2 font-weight-bold">
              Zarabiaj razem z nami. U nas polecanie opłaca się podwójnie !
            </h5>
            <div>
              Jeśli masz dobre zdanie o programie {{ program.toUpperCase()
              }}<sup>®</sup>, to poleć go swoim znajomym ! Ty zarabiasz
              dodatkowe pieniądze, a nowy Klient otrzymuje szereg rabatów.
            </div>
          </b-card-text>
          <b-card-text>
            <b-row>
              <b-col>
                <b-row>
                  <b-col lg="2" class="text-right pr-0">
                    <p><i class="fas fa-link"></i></p>
                  </b-col>
                  <b-col
                    ><span class="mb-2"
                      >Rekomenduj {{ program.toUpperCase() }}<sup>®</sup> i
                      poinformuj o akcji swojego znajomego.</span
                    ><br />
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row>
                  <b-col lg="2" class="text-right pr-0">
                    <p><i class="fas fa-user-plus"></i></p>
                  </b-col>
                  <b-col
                    ><span
                      >Znajomy kupuje {{ program.toUpperCase() }}<sup>®</sup> i
                      podaje Twoje dane.</span
                    >
                    <br />
                    <p>Zyskuje 20% rabatu na nowy program, moduły i dodatki.</p>
                    <br />
                    <!--                    <p>-->
                    <!--                      Warunkiem skorzystania z promocji jest zaznaczenie w-->
                    <!--                      formularzu zamówienia przynajmniej 2 modułów.-->
                    <!--                    </p>-->
                  </b-col>
                </b-row>
              </b-col>
              <b-col>
                <b-row>
                  <b-col lg="2" class="text-right pr-0">
                    <p><i class="fas fa-piggy-bank"></i></p>
                  </b-col>
                  <b-col
                    ><p class="mb-0">Do Twojego portfela trafia prowizja.</p>
                    <span v-if="program === 'skp'">
                      <p class="mb-1">Za każde polecenie otrzymujesz:</p>
                      <p class="mb-0 mt-1">
                        <img :src="styles.check" alt="check" class="mb-1" />
                        SKP<sup>®</sup> Firma: <strong>50 zł netto</strong>
                      </p>
                      <p class="mb-0 mt-1">
                        <img :src="styles.check" alt="check" class="mb-1" />
                        SKP<sup>®</sup> Biuro: <strong>100 zł netto</strong>
                      </p>
                    </span>
                    <span v-if="program === 'sam'">
                      <p class="mb-0 mt-1">
                        Za każde polecenie SAM<sup>®</sup> otrzymasz 20 zł netto
                      </p></span
                    >
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                ><p class="py-2 my-2 offset-3">
                  <span
                    id="info"
                    @mouseenter="toggleInfoFocus()"
                    @mouseleave="toggleInfoFocus()"
                    class="checkboxPointer font-size-16 p-2"
                  >
                    <img
                      v-if="infoFocus"
                      :src="styles.info_focus"
                      alt="check"
                      class="pb-1"
                    />
                    <img v-else :src="styles.info" alt="check" class="pb-1" />
                    Poznaj szczegółowe
                    <a :href="link" target="_blank"
                      >zasady promocji i listę korzyści ></a
                    >
                  </span>
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <p class="mt-2">
                  <strong>Zarekomenduj nasze SKP<sup>®</sup>! </strong>
                </p>
                <p class="mb-0">
                  <span @click="copyUrl"
                    ><b-button
                      id="copyBtn"
                      @click="showTooltip = true"
                      variant="link"
                      class="m-0 p-0"
                      >Skupiuj link</b-button
                    ></span
                  >
                  do formularza zamówień SKP<sup>®</sup>. Następnie wklej i
                  prześlij go znajomemu przez email, SMS-em lub dowolny
                  komunikator np. Skype, WhatsApp, Facebook Messenger.<br />
                  Aby znajomy mógł skorzystać z promocji, pamiętaj o podaniu mu:
                  swojego NIP, numer licencji, imienia oraz adres email.
                </p>
              </b-col>
            </b-row>

            <b-row>
              <!--              <b-col>-->
              <!--                                  <p class="mt-2">-->
              <!--                                  <strong-->
              <!--                                    >Nasz program możesz zarekomendować na dwa sposoby:</strong-->
              <!--                                  >-->
              <!--                                </p>-->
              <!--                <p class="mb-0"><strong>Sposób 1</strong></p>-->
              <!--                <p class="mb-0">-->
              <!--                  <span @click="copyUrl"-->
              <!--                    ><b-button-->
              <!--                      id="copyBtn"-->
              <!--                      @click="showTooltip = true"-->
              <!--                      variant="link"-->
              <!--                      class="m-0 p-0"-->
              <!--                      >Pobierz link</b-button-->
              <!--                    ></span-->
              <!--                  >-->
              <!--                  <b-popover-->
              <!--                    :show.sync="showTooltip"-->
              <!--                    @shown="hideTooltipLater"-->
              <!--                    placement="top"-->
              <!--                    target="copyBtn"-->
              <!--                    title="Skopiowano do schowka"-->
              <!--                  >-->
              <!--                  </b-popover>-->
              <!--                  do formularza zamówienia potem wklej i prześlij go znajomemu-->
              <!--                  przez e-mail, SMS-em lub dowolny komunikator np. Skype,-->
              <!--                  WhatsApp czy Facebook Messenger.-->
              <!--                </p>-->
              <!--                <p>-->
              <!--                  Aby znajomy mógł skorzystać z promocji, wraz z linkiem do-->
              <!--                  zamówienia podaj mu także swój NIP i numer licencji.-->
              <!--                </p>-->
              <!--                <p class="mb-0"><strong>Sposób 2</strong></p>-->
              <!--                <p class="mb-1">-->
              <!--                  Wpisz e-mail znajomego, a wyślemy mu wiadomość z informacją o-->
              <!--                  promocji. Kliknij Zobacz treść e-maila i zdecyduj, czy chcesz-->
              <!--                  już teraz podać znajomemu swój numer licencji i NIP niezbędny-->
              <!--                  do skorzystania z promocji.-->
              <!--                </p>-->
              <!--              </b-col>-->
            </b-row>
            <b-row>
              <!--              <b-col>-->
              <!--                <b-form>-->
              <!--                  <b-row>-->
              <!--                    <b-col lg="3" class="pr-2">-->
              <!--                      <b-form-group-->
              <!--                        label-cols-lg="auto"-->
              <!--                        label="E-mail znajomego"-->
              <!--                        label-for="friendEmail"-->
              <!--                      >-->
              <!--                        <b-form-input-->
              <!--                          id="friendEmail"-->
              <!--                          v-model="friendEmail"-->
              <!--                          :state="validateEmail1"-->
              <!--                          aria-describedby="email-feedback"-->
              <!--                        ></b-form-input>-->
              <!--                        <b-form-invalid-feedback id="friendEmail-feedback">-->
              <!--                          Błędny e-mail.-->
              <!--                        </b-form-invalid-feedback>-->
              <!--                      </b-form-group>-->
              <!--                    </b-col>-->
              <!--                    <b-col lg="3" class="px-2">-->
              <!--                      <b-form-group-->
              <!--                        label-cols-lg="auto"-->
              <!--                        label="Twój e-mail"-->
              <!--                        label-for="userEmail"-->
              <!--                      >-->
              <!--                        <b-form-input-->
              <!--                          id="userEmail"-->
              <!--                          v-model="userEmail"-->
              <!--                          :state="validateEmail2"-->
              <!--                          aria-describedby="email-feedback"-->
              <!--                        ></b-form-input>-->
              <!--                        <b-form-invalid-feedback id="userEmail-feedback">-->
              <!--                          Błędny e-mail.-->
              <!--                        </b-form-invalid-feedback>-->
              <!--                      </b-form-group>-->
              <!--                    </b-col>-->
              <!--                    <b-col lg="2" class="px-2">-->
              <!--                      <b-form-group-->
              <!--                        label-cols-lg="auto"-->
              <!--                        label="Podpis"-->
              <!--                        label-for="username"-->
              <!--                      >-->
              <!--                        <b-form-input-->
              <!--                          id="username"-->
              <!--                          v-model="username"-->
              <!--                          :state="validateUsername"-->
              <!--                          aria-describedby="username-feedback"-->
              <!--                        ></b-form-input>-->
              <!--                        <b-form-invalid-feedback id="username-feedback">-->
              <!--                          Dodaj podpis.-->
              <!--                        </b-form-invalid-feedback>-->
              <!--                      </b-form-group>-->
              <!--                    </b-col>-->
              <!--                    <b-col class="px-2">-->
              <!--                      <b-button-->
              <!--                        size="sm"-->
              <!--                        variant="secondary"-->
              <!--                        class="ml-auto btn-color mt-1"-->
              <!--                        @click.prevent="sendEmail()"-->
              <!--                        >Wyślij informacje o promocji-->
              <!--                      </b-button>-->
              <!--                    </b-col>-->
              <!--                    <b-col class="px-1 pt-2">-->
              <!--                      <a href="#" v-b-modal.modal-email>Zobacz treść e-maila</a>-->
              <!--                    </b-col>-->
              <!--                    <b-modal-->
              <!--                      id="modal-email"-->
              <!--                      title="Treść e-maila do znajomego"-->
              <!--                      ok-only-->
              <!--                    >-->
              <!--                      <p>Witam,</p>-->
              <!--                      <p>-->
              <!--                        Prowadząc moją firmę korzystam z programu księgowego-->
              <!--                        {{ program.toUpperCase() }}<sup>®</sup>, który chcę Ci-->
              <!--                        polecić. Decydując się na zakup programu z mojego-->
              <!--                        polecenia, otrzymasz pakiet promocji:-->
              <!--                      </p>-->
              <!--                      <ul>-->
              <!--                        <li>-->
              <!--                          20% na zakup wersji bazowej-->
              <!--                          <span v-if="program === 'skp'"-->
              <!--                            >SKP<sup>®</sup> Start (Firma lub Biuro)</span-->
              <!--                          ><span v-else>SAM<sup>®</sup> Basic</span>-->
              <!--                        </li>-->
              <!--                        <li>20% na zakup modułów</li>-->
              <!--                        <li>20% na zakup pomocnych dodatków</li>-->
              <!--                      </ul>-->
              <!--                      <p>-->
              <!--                        Więcej informacji na temat programu oraz akcji-->
              <!--                        promocyjnej znajdziesz na stronie: {{ link }}.-->
              <!--                      </p>-->
              <!--                      <p v-if="useNip">-->
              <!--                        Polecam Ci {{ program.toUpperCase() }}<sup>®</sup> i-->
              <!--                        jeżeli zdecydujesz się na jego zakup, podaj w zamówieniu-->
              <!--                        mój NIP: {{ client.NIP }} oraz numer licencji:-->
              <!--                        {{ client.LIC }}.-->
              <!--                      </p>-->
              <!--                      <p v-else>-->
              <!--                        Polecam Ci {{ program.toUpperCase() }}<sup>®</sup> i-->
              <!--                        jeżeli zdecydujesz się na jego zakup, przekażę Ci moje-->
              <!--                        dane (NIP i nr licencji) potrzebne do uzyskania rabatów.-->
              <!--                      </p>-->
              <!--                      <p class="mb-1">Pozdrawiam serdecznie,</p>-->
              <!--                      <p class="mb-1">{{ username }}</p>-->
              <!--                      <p v-if="userEmailSet">{{ userEmailSet }}</p>-->
              <!--                      <p v-else>{{ userEmail }}</p>-->
              <!--                      <hr class="mb-3 modal-email-hr" />-->
              <!--                      <span-->
              <!--                        @click="changeUseNip(useNip === false)"-->
              <!--                        class="mr-1 checkboxPointer"-->
              <!--                      >-->
              <!--                        <img-->
              <!--                          v-if="useNip === true"-->
              <!--                          :src="styles.checkbox_new"-->
              <!--                          alt="check"-->
              <!--                          class="mb-1"-->
              <!--                        />-->
              <!--                        <input v-else type="checkbox" />-->
              <!--                        Tak, podaj mój NIP i nr licencji-->
              <!--                      </span>-->
              <!--                    </b-modal>-->
              <!--                  </b-row>-->
              <!--                  <b-alert-->
              <!--                    v-if="emailSend"-->
              <!--                    v-model="emailSend"-->
              <!--                    variant="success"-->
              <!--                    dismissible-->
              <!--                    class="mt-2 mb-3"-->
              <!--                  >-->
              <!--                    E-mail został wysłany.-->
              <!--                  </b-alert>-->
              <!--                  <b-alert-->
              <!--                    v-if="!emailSend"-->
              <!--                    v-model="emailSend"-->
              <!--                    variant="danger"-->
              <!--                    dismissible-->
              <!--                    class="mt-2 mb-3"-->
              <!--                  >-->
              <!--                    Błąd wysyłki e-maila.-->
              <!--                  </b-alert>-->

              <!--                  <b-row v-if="invalidEmailError">-->
              <!--                    <b-col>-->
              <!--                      <p class="text-danger small">-->
              <!--                        Na podany adres e-mail zostało już wysłane powiadomienie-->
              <!--                        o promocji.-->
              <!--                      </p>-->
              <!--                    </b-col>-->
              <!--                  </b-row>-->
              <!--                  <b-row>-->
              <!--                    <b-col>-->
              <!--                      <span-->
              <!--                        id="info"-->
              <!--                        @mouseenter="toggleInfoFocus()"-->
              <!--                        @mouseleave="toggleInfoFocus()"-->
              <!--                        class="checkboxPointer font-size-16 p-2"-->
              <!--                      >-->
              <!--                        <img-->
              <!--                          v-if="infoFocus"-->
              <!--                          :src="styles.info_focus"-->
              <!--                          alt="check"-->
              <!--                          class="pb-1"-->
              <!--                        />-->
              <!--                        <img-->
              <!--                          v-else-->
              <!--                          :src="styles.info"-->
              <!--                          alt="check"-->
              <!--                          class="pb-1"-->
              <!--                        />-->
              <!--                        Poznaj szczegółowe-->
              <!--                        <a :href="link" target="_blank"-->
              <!--                          >zasady promocji i listę korzyści ></a-->
              <!--                        >-->
              <!--                      </span>-->
              <!--                    </b-col>-->
              <!--                  </b-row>-->
              <!--                </b-form>-->
              <!--              </b-col>-->
            </b-row>
          </b-card-text>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card title="Mój portfel" class="title-inline recommend">
            <b-card-text>
              <b-row>
                <b-col lg="auto">
                  <span class="mb-2">
                    Dostępne środki
                    <span class="readonlyInput px-2 py-1">{{ balance }}</span>
                    zł netto
                  </span>
                </b-col>
                <b-col v-if="waitingBalance" lg="auto">
                  <span class="mr-3">+</span>
                  Środki w poczekalni
                  <span class="readonlyInput px-2 py-1 text-waiting">{{
                    waitingBalance
                  }}</span>
                  zł
                  <span
                    v-b-popover.hover.top="
                      'Środki z polecenia dostępne będą po upływie 14 dni roboczych od\n' +
                      '                rozliczenia zakupu Znajomego. Zasilą wtedy kwotę Dostępnych\n' +
                      '                środków w Twoim portfelu.'
                    "
                    @mouseenter="toggleInfoWaitingFocus()"
                    @mouseleave="toggleInfoWaitingFocus()"
                    class="checkboxPointer ml-2"
                  >
                    <img
                      v-if="infoWaitingFocus"
                      :src="styles.info_focus"
                      class="pb-1"
                    />
                    <img v-else :src="styles.info" alt="check" class="pb-1" />
                  </span>
                </b-col>
                <b-col v-if="waitingBalance">
                  <span class="mb-2">
                    Twój zysk
                    <span class="readonlyInput px-2 py-1 text-waiting">{{
                      balance + waitingBalance
                    }}</span>
                    zł netto
                  </span>
                </b-col>
              </b-row>

              <span v-if="waitingBalance"> </span>
              <p class="mb-2 mt-2">
                Wykorzystaj na zakup dodatków, modułów lub Opieki Serwisowej
                <router-link
                  :to="{
                    name: 'Order',
                  }"
                  tag="button"
                  class="
                    btn
                    mx-2
                    update-licence
                    btn-color btn-secondary
                    px-2
                    py-1
                  "
                  >Przejdź do zamówienia
                </router-link>
              </p>
              <p class="mb-2">
                Jeżeli kwota środków wynosi {{ minAmount }} zł netto lub więcej,
                możesz dokonać wypłaty
                <b-button
                  variant="secondary"
                  class="ml-auto btn-color mx-2 px-2 py-1"
                  @click.prevent="transfer()"
                  >Wypłać środki
                </b-button>
                <span class="text-danger" v-if="notEnoughFunds"
                  >Brak wystarczającej kwoty do dokanania wypłaty. Polecaj
                  {{ program.toUpperCase() }}<sup>®</sup> i zbierz min.
                  {{ minAmount }} zł.
                </span>
              </p>
              <b-alert
                v-if="transferRequestSend"
                v-model="transferRequestSend"
                variant="success"
                dismissible
                class="mt-2 mb-3"
              >
                Faktura wysłana poprawnie. Zweryfikujemy poprawność faktury i
                przelejemy środki w ciągu 14 dni na podane konto.
              </b-alert>
              <b-alert
                v-if="!transferRequestSend"
                v-model="transferRequestSend"
                variant="danger"
                dismissible
                class="mt-2 mb-3"
              >
                Błąd wysyłki faktury. Sprawdź błędy.
              </b-alert>
              <hr v-if="transferRequest" />
              <b-form v-if="transferRequest">
                <b-row>
                  <b-col lg="auto">
                    <b-form-group
                      label-cols-lg="auto"
                      label="Kwota do wypłaty"
                      label-for="amount"
                    >
                      <b-form-input
                        id="amount"
                        v-model="amountToTransfer"
                        :state="validateAmount"
                        aria-describedby="amount-feedback"
                        style="max-width: 60px"
                      ></b-form-input>
                      <b-form-invalid-feedback id="amount-feedback">
                        Kwota nie może być niższa niż {{ minAmount }} ani
                        większa niż dostępne środki.
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <span class="mt-2">zł netto</span>
                </b-row>
                <b-row>
                  <b-col
                    ><p class="small text-secondary mb-0">
                      <sup>*</sup>Kwotę wypłacanych środków należy powiększyć o
                      należny podatek od towarów i usług (VAT).
                    </p></b-col
                  >
                </b-row>
                <!--            <b-row>-->
                <!--              <b-col lg="12">-->
                <!--                <b-form-group-->
                <!--                  label-cols-lg="auto"-->
                <!--                  label="Podaj numer rachunku, na który mamy dokonać wypłaty środków"-->
                <!--                  label-for="accountNumber"-->
                <!--                >-->
                <!--                  <b-form-input-->
                <!--                    id="accountNumber"-->
                <!--                    v-model="accountNumber"-->
                <!--                    :state="validateAccountNumber"-->
                <!--                    aria-describedby="accountNumber-feedback"-->
                <!--                  ></b-form-input>-->
                <!--                  <b-form-invalid-feedback id="accountNumber-feedback">-->
                <!--                    Niepoprawny numer konta.-->
                <!--                  </b-form-invalid-feedback>-->
                <!--                </b-form-group>-->
                <!--              </b-col>-->
                <!--            </b-row>-->
                <b-row>
                  <b-col lg="auto" class="mt-2">
                    <span
                      >Przelew zrealizujemy w ciągu 7 dni od otrzymania
                      faktury</span
                    >
                  </b-col>
                  <b-col lg="4">
                    <b-form-group
                      label="Dołącz fakturę"
                      label-cols-lg="auto"
                      class="mb-1 row-with-legend"
                    >
                      <b-form-file
                        v-model="invoice"
                        name="invoice"
                        plain
                        class="mt-2 checkboxPointer"
                        accept=".jpg, .png, .pdf"
                        :state="validateFile"
                        aria-describedby="invoice-feedback"
                      ></b-form-file>
                      <b-form-invalid-feedback id="invoice-feedback">
                        Dołącz fakturę.
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col lg="auto" v-if="invoice" class="ml-0 pl-0">
                    <b-button
                      @click="invoice = null"
                      variant="link"
                      class="mt-1"
                      >Usuń plik
                    </b-button>
                  </b-col>
                  <b-col lg="auto" class="mt-2">
                    <b-button
                      size="sm"
                      variant="secondary"
                      class="ml-auto btn-color"
                      @click.prevent="sendInvoice()"
                      >Wyślij fakturę
                    </b-button>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    ><p class="small text-secondary">
                      <a
                        href="http://docs.format.wroc.pl/przykladowa_faktura_rozliczenia_promocji_Polec_znajomemu.pdf"
                        target="_blank"
                        >Zobacz przykładową fakturę</a
                      >
                    </p></b-col
                  >
                </b-row>
                <b-row v-if="accountNumberError">
                  <b-col>
                    <p class="text-danger small">
                      {{ accountNumberError }}
                    </p>
                  </b-col>
                </b-row>
                <b-row v-if="transferRequestError">
                  <b-col>
                    <p class="text-danger small">
                      Uzupełnij poprawnie kwotę i numer rachunku bankowego oraz
                      dołącz fakturę.
                    </p>
                  </b-col>
                </b-row>
              </b-form>
            </b-card-text>
          </b-card>
          <b-card
            title="Zasilenia Twojego portfela"
            class="title-inline recommend"
          >
            <b-card-text>
              <b-table
                v-if="allOrders.length > 0"
                hover
                :items="allOrders"
                :fields="fields"
                :tbody-tr-class="rowClass"
                foot-clone
              >
                <template #cell(amount)="data">
                  <div v-if="data.item.amount > 0" class="text-right mr-3">
                    {{ data.item.amount }} zł
                  </div>
                  <div v-else>0</div>
                </template>
                <template #cell(date)="data">
                  <span>{{ formatDate(data.item.date) }}</span>
                </template>
                <template #cell(used)="data">
                  <span>{{ status(data.item) }}</span>
                </template>
                <template #foot(name)><span></span></template>
                <template #foot(date)>
                  <span>Twój zysk razem netto</span></template
                >
                <template #foot(amount)>
                  <div class="text-right mr-3">{{ sum }} zł</div>
                </template>
                <template #foot(used)><span></span></template>
              </b-table>
              <span v-else class="text-center">Brak poleceń</span>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <p class="bot-link" @click="runChat">
          <strong>Potrzebujesz szybkiej pomocy?<br /></strong>
          Zapytaj Wirtualnego Asystenta SKP<sup>®</sup> >
        </p>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import sprintfjs from 'sprintf-js';
import moment from 'moment';

export default {
  name: 'RecommendAFriend',
  props: {
    styles: {},
  },
  data() {
    return {
      balance: 0,
      waitingBalance: null,
      friendEmail: '',
      infoFocus: false,
      infoWaitingFocus: false,
      amount: 250,
      accountNumber: null,
      invoice: null,
      fields: [
        { key: 'name', label: 'Polecenie / Zasilenie' },
        { key: 'date', label: 'Data' },
        { key: 'amount', label: 'Twój zysk' },
        { key: 'used', label: 'Status' },
      ],
      allOrders: [],
      notEnoughFunds: false,
      recommendedEmails: [],
      invalidEmailError: false,
      emailSend: null,
      emailsValidated: false,
      transferValidated: false,
      transferRequest: false,
      transferRequestError: false,
      transferRequestSend: null,
      amountToTransferSet: null,
      userEmailSet: null,
      username: null,
      showTooltip: false,
      accountNumberError: false,
      useNip: true,
    };
  },
  computed: {
    ...mapGetters({
      currentOs: 'auth/currentOs',
      program: 'getProgram',
      client: 'auth/client',
      licence: 'auth/userLicence',
    }),
    userEmail: {
      get() {
        return this.client.E1;
      },
      set(value) {
        this.userEmailSet = value;
      },
    },
    minAmount() {
      return this.program === 'skp' ? 200 : 100;
    },
    amountToTransfer: {
      get() {
        return this.balance;
      },
      set(value) {
        this.amountToTransferSet = value;
      },
    },
    link() {
      return this.program === 'skp'
        ? 'https://www.ksiega-podatkowa.pl/promocje-skp/polec-znajomemu'
        : 'https://www.samozatrudnienie.pl/promocje/polec-znajomemu';
    },
    validateEmail1() {
      const regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,50}))$/;

      if (
        this.emailsValidated &&
        (this.friendEmail === '' || this.friendEmail === null)
      ) {
        return false;
      } else if (!this.emailsValidated) {
        return null;
      }

      return regex.test(String(this.friendEmail).toLowerCase()) ? null : false;
    },
    validateUsername() {
      return this.emailsValidated &&
        (!this.username || this.username.trim() === '')
        ? false
        : null;
    },
    validateEmail2() {
      const regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,50}))$/;

      if (
        this.emailsValidated &&
        (this.userEmail === '' || this.userEmail === null)
      ) {
        return false;
      }

      return regex.test(String(this.userEmail).toLowerCase()) ? null : false;
    },
    validateAmount() {
      let amount = this.amountToTransferSet
        ? Number(this.amountToTransferSet)
        : this.amountToTransfer;

      return amount < this.minAmount || amount > this.balance ? false : null;
    },
    validateAccountNumber() {
      if (this.accountNumber !== '' && this.accountNumber !== null) {
        return this.isAccountNumberCorrect() ? null : false;
      }
      return null;
    },
    validateFile() {
      return this.transferValidated && this.invoice === null ? false : null;
    },
    copyOrderLink() {
      return this.program === 'skp'
        ? 'https://www.ksiega-podatkowa.pl/zamowienie'
        : 'https://www.samozatrudnienie.pl/zamowienie';
    },
    sum() {
      return this.allOrders.reduce(function (sum, item) {
        return sum + Number(item.amount);
      }, 0);
    },
  },
  created() {
    this.$store.commit('order/resetOrder');
    this.$store.commit('order/resetSteps');
    this.getWalletBalance();
    this.getRecommendedEmails();
  },
  methods: {
    getWalletBalance() {
      axios
        .get('/api/getWalletBalance/' + this.program + '/' + this.licence)
        .then(({ data }) => {
          this.balance = data.balance;
          this.waitingBalance = data.waitingBalance;
          this.allOrders = data.recommendations;
        });
    },
    getRecommendedEmails() {
      axios
        .get('/api/recommendedEmails/' + this.program + '/' + this.licence)
        .then(({ data }) => {
          this.recommendedEmails = data;
        });
    },
    toggleInfoFocus() {
      this.infoFocus = !this.infoFocus;
    },
    toggleInfoWaitingFocus() {
      this.infoWaitingFocus = !this.infoWaitingFocus;
    },
    sendEmail() {
      this.invalidEmailError = false;
      this.emailsValidated = false;
      this.validateEmail();

      if (!this.invalidEmailError) {
        axios
          .post('/api/sendEmailWithRecommendation', {
            from: this.userEmailSet ? this.userEmailSet : this.userEmail,
            fromName: this.username,
            email_to: this.friendEmail,
            program: this.program,
            lic: this.licence,
            nip: this.client.NIP,
            useNip: this.useNip,
          })
          .then(() => {
            this.emailSend = true;
            this.getRecommendedEmails();
          })
          .catch((error) => (this.emailSend = false));
      }
    },
    validateEmail() {
      this.emailsValidated = true;
      let emailExist = Object.values(this.recommendedEmails).filter(
        (item) => item.email_to === this.friendEmail
      );

      if (emailExist.length > 0) {
        this.invalidEmailError = true;
      }
    },
    transfer() {
      this.notEnoughFunds = false;
      if (this.amountToTransfer < this.minAmount) {
        this.notEnoughFunds = true;
      } else {
        this.transferRequest = true;
      }
    },
    sendInvoice() {
      this.transferValidated = false;
      this.transferRequestError = false;
      this.accountNumberError = false;

      this.validateTransfer();

      if (!this.transferRequestError) {
        let data = new FormData();
        data.append('lic', this.licence);
        data.append('nip', this.client.NIP);
        data.append('N1', this.client.N1);
        data.append('N2', this.client.N2);
        data.append('program', this.program);
        data.append(
          'amount',
          this.amountToTransferSet
            ? Number(this.amountToTransferSet)
            : this.amountToTransfer
        );
        data.append('type', 'transfer');
        // data.append('account_number', this.accountNumber);
        data.append('invoice', this.invoice);
        data.append('balance', this.balance);

        axios
          .post('/api/sendTransferRequest', data, {
            headers: {
              'content-type': 'multipart/form-data',
            },
          })
          .then((response) => {
            this.transferRequestSend = true;
            this.transferRequest = false;
            this.getWalletBalance();
          })
          .catch((error) => {
            this.transferRequestSend = false;
            this.accountNumberError = error.accountNumber;
          });
      }
    },
    validateTransfer() {
      let amount = this.amountToTransferSet
        ? Number(this.amountToTransferSet)
        : this.amountToTransfer;
      if (
        amount < this.minAmount ||
        amount > this.balance
        // || !this.isAccountNumberCorrect()
      ) {
        this.transferRequestError = true;
      }
      this.transferValidated = true;
    },
    copyUrl() {
      const el = document.createElement('textarea');
      el.value = this.copyOrderLink;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
    },
    hideTooltipLater() {
      setTimeout(() => {
        this.showTooltip = false;
      }, 1000);
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return;
      if (item.status === 'used') return 'text-secondary';
      if (item.type === 'custom') return 'font-italic';
      if (item.status === 'waiting') return 'text-waiting';
    },
    waiting(item) {
      return (
        item.date >= moment().subtract(14, 'd').format('YYYY-MM-DD') &&
        item.orderId
      );
    },
    isAccountNumberCorrect() {
      if (!this.accountNumber) return false;
      let account = this.accountNumber.replace(/\s/g, '');

      if (account.length !== 26) {
        return false;
      }

      account += '252100';
      let wag = [
        57, 93, 19, 31, 71, 75, 56, 25, 51, 73, 17, 89, 38, 62, 45, 53, 15, 50,
        5, 49, 34, 81, 76, 27, 90, 9, 30, 3, 10, 1,
      ];
      let sum = 0;

      for (let i = 0; i < 30; i++) {
        sum += account[i + 2] * wag[i];
      }

      let number = sprintf('%02d', 98 - (sum % 97));

      return account[0] === number[0] && account[1] === number[1];
    },
    programName(program) {
      if (program === 'SKP Firma - START') return 'SKP<sup>®</sup> Firma';
      if (program === 'SKP Biuro - START') return 'SKP<sup>®</sup> Biuro';

      return program;
    },
    changeUseNip(value) {
      this.useNip = value;
    },
    status(item) {
      if (item.status === 'available') return 'Dostępne';
      if (item.status === 'waiting') return 'W poczekalni';
      if (item.status === 'used') return 'Wykorzystane';
    },
    formatDate(item) {
      return moment(item).format('YYYY-MM-DD');
    },
    runChat() {
      document.getElementById('chatbase-bubble-button').click();
    },
  },
};
</script>

<style scoped>
b-link {
  color: red;
}

.btn-link {
  text-decoration: underline;
}

.modal-email-hr {
  margin: 0 -16px 0 -16px;
}

.table td:first-child {
  padding-right: 0 !important;
  margin-right: 0;
}
</style>
